import axios from "axios";

// REACT_APP_BACKEND_URL boşsa same-origin (relative) kullan — production nginx
// aynı domain'den /api/* proxy yapıyorsa bu yeterli.
const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = ENV_URL && ENV_URL !== "undefined" ? ENV_URL.replace(/\/+$/, "") : "";

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Beklenmeyen hata";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export const BACKEND = BACKEND_URL;
